import React, { useState } from "react";
import { FaGoogle } from "react-icons/fa";
import { HiArrowRight } from "react-icons/hi";
import { useNavigate } from "react-router-dom";
import API from "../../utils/api";
import ImageLeft from '../../Images/side.png';
import ImageRight from '../../Images/Branche1.png';
import heroBg from "../../Images/maintoo.jpeg";
import rightiImage from "../../Images/image.png";
import heroBgDesktop from "../../Images/maintoo_sharpened_300kb.webp";
import heroBgMobile from "../../Images/maintoo2.png";
import image from '../../Images/Ihr_Unternehmen.webp'
const HeroSection = () => {
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSearch = async () => {
    if (!query.trim()) return;

    try {
      setLoading(true);

      const res = await API.post("/google/search", {
        textQuery: query,
      });

      if (res.status === 200 && res.data) {
        navigate("/Bewertungsmanager-1", {
          state: {
            places: res.data,
          },
        });

      }
    } catch (err) {
      console.log("API Error:", err);
      alert("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section
      id="heroSection"
      className="
      relative w-full
      min-h-[100vh] 2xl:min-h-[70vh]
      flex items-center
      bg-cover bg-no-repeat
      bg-[center_right]
      lg:bg-center
      a
      pb-8
    "
    >
      {/* CONTENT WRAP */}
      <div className="w-[90%] 2xl:w-[70%] mx-auto ">
        <div className="flex flex-col lg:flex-row items-center gap-10">

          {/* LEFT */}
          <div className="relative z-10 w-full lg:w-1/2 pt-20 pb-0 md:pt-20 md:pb-20 space-y-6">
            <h1 className="mt-4  h1-mb h1-md h1-lg h1-2xl">
              Jede schlechte{" "}
              <span className="relative inline-block md:mt-4 md:mb-2">
                <span className="relative inline-block">
                  <span className="easiest-badge">Bewertung</span>
                  <span className="absolute -top-2 -right-2 h-2 w-2 rotate-12 rounded-full bg-lime-300" />
                  <span className="absolute -top-3 right-3 h-3 w-[2px] rotate-12 bg-lime-300" />
                </span>
              </span>{" "}
              kostet Umsatz
            </h1>

            <p className="mt-6 md:text-xl leading-6 text-[#163949]/70">
              Sehen Sie sofort, welche Google-Bewertungen Ihre Kunden abschrecken –
              und was Sie dagegen tun können.
            </p>

            <p className="text-gray-800 text-lg md:text-xl font-semibold mb-6">
              Bewertungsmanagement-Selfservice
            </p>

            <div className="max-w-xl relative">
              <div className="relative flex items-center w-full">
                <FaGoogle
                  className="absolute left-4 top-1/2 -translate-y-1/2 text-2xl pointer-events-none"
                  style={{
                    background:
                      "linear-gradient(45deg, #4285F4, #0b2b40, #FBBC05, #EA4335)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                  }}
                />

                <input
                  type="text"
                  placeholder="Name Ihres Unternehmens"
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                  onKeyDown={(e) => e.key === "Enter" && handleSearch()}
                  className="
      w-full pl-12 pr-[160px] md:pr-[220px] py-3
      rounded-xl
      bg-slate-50
      border border-slate-300
      text-slate-900 text-[12px] md:text-lg placeholder-slate-500

      transition-all duration-200 ease-out

      hover:border-slate-400

      focus:outline-none
      focus:bg-slate-100
      focus:border-[#0b2b40]
      focus:ring-4 focus:ring-[#0b2b40]/25
      focus:shadow-[inset_0_0_0_1px_#0b2b40,0_10px_25px_-10px_rgba(11,43,64,0.35)]
    "
                />

                <button
                  onClick={handleSearch}
                  disabled={loading}
                  className="
      absolute right-2 top-1/2 -translate-y-1/2
      bg-[#0b2b40] text-white font-semibold
      px-3 md:px-6 py-2
      rounded-xl
      flex items-center gap-2

      shadow-md transition-all duration-200
      hover:shadow-lg hover:opacity-95
      active:scale-[0.97]

      disabled:opacity-60 disabled:cursor-not-allowed
      text-[10px] md:text-[16px]
    "
                >
                  <span className="whitespace-nowrap">
                    {loading ? "Bitte warten..." : "Potenzial anzeigen"}
                  </span>
                  <HiArrowRight className="text-lg transform -rotate-24" />
                </button>
              </div>



              <p className="text-gray-800 text-sm mt-3">
                Jetzt kostenlos Ihr Google-Profil analysieren
              </p>
            </div>

            <p className="text-gray-800 text-base mt-8 font-medium">
              Bereits von 5.000+ Kunden genutzt
            </p>
          </div>

          {/* RIGHT */}
          <div className="relative z-10 w-full lg:w-1/2 flex justify-center">
            {/* Responsive height: no fixed 800px */}
            <div className="w-full h-full ">
              <img
                src={image}
                alt="Hero"
                className="w-full h-full object-contain mt-0 lg:mt-8"
                draggable={false}
              />
            </div>
          </div>

        </div>
      </div>

      <style>
        {`
        @media (max-width: 768px) {
          section {
            background-position: center right;
          }
        }
      `}
      </style>
    </section>
  );


};

export default HeroSection;
